export default __webpack_public_path__ + "static/media/travelers.d88a1b63.jpg";